import { render, staticRenderFns } from "./FormPositionStyleEditor.vue?vue&type=template&id=230efcb0&scoped=true"
import script from "./FormPositionStyleEditor.vue?vue&type=script&lang=js"
export * from "./FormPositionStyleEditor.vue?vue&type=script&lang=js"
import style0 from "./FormPositionStyleEditor.vue?vue&type=style&index=0&id=230efcb0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230efcb0",
  null
  
)

export default component.exports